module.exports = __webpack_public_path__ + "img/enseption_02.01425df3.png";